<template>
  <div style="background: #fff">
    <div class="pz-box">
      <!--标题-->
      <h2 class="upload-titile input-title-hq" :class="required ? 'red-required' : ''">
        {{ title }}
      </h2>
      <!--内容-->
      <van-field :name="name" :rules="[{ required: required, message: '请选择道路经营范围' }]">
        <template #input>
          <van-checkbox-group v-model="selectedOptions" :disabled="disabled">
            <van-cell-group>
              <van-cell
                v-for="(item, index) in options"
                :key="item.id"
                :title="`${item.pinming} —— ${item.wxhwlb}`"
                clickable
                title-class="title-class-hq"
                @click="toggle(index)"
              >
                <template #right-icon>
                  <van-checkbox :name="`${item.pinming}`" ref="checkboxes" />
                </template>
              </van-cell>
            </van-cell-group>
          </van-checkbox-group>
        </template>
      </van-field>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      name: {
        type: String,
        required: true,
      },
      title: {
        type: String,
        default: '',
      },
      required: {
        type: Boolean,
        default: true,
      },
      options: {
        type: Array,
        default: () => [],
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      // 勾选项组
      modelValue: {
        type: Array,
        default: () => [],
      },
    },
    computed: {
      selectedOptions: {
        get() {
          return this.modelValue;
        },
        set(value) {
          // console.log(value);
          this.$emit('update:modelValue', value);
        },
      },
    },
    methods: {
      validateEmpty(val, rule) {
        if (this.required && !this.required) {
          return true;
        }
        return val.length !== 0;
      },

      toggle(index) {
        if (this.disabled) return;
        this.$refs.checkboxes[index].toggle();
        setTimeout(() => {
          this.selectedOptions = this.$refs.checkboxes
            .filter((item) => {
              return item.checked;
            })
            .map((iten) => {
              return iten.name;
            });
        }, 0);
      },
    },
  };
</script>
<style lang="scss" scoped>
  .pz-box {
    .red-required {
      position: relative;
      padding-left: 0.75rem;

      &::before {
        position: absolute;
        left: 0;
        color: #ee0a24;
        font-size: 15px;
        content: '*';
      }
    }
    ::v-deep .van-field {
      padding: 0;
      .van-field__value {
        display: flex;
        flex-direction: column;
        // 表单内容
        .van-field__body {
          order: 2;
          .van-field__control {
            .van-checkbox-group {
              width: 100%;
            }
          }
        }
        //表单校验项
        .van-field__error-message {
          padding-left: 1rem;
          order: 1;
        }
      }
    }
  }

  .upload-titile {
    padding: 0.675rem 1rem;
  }
</style>
